import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { ScrollArea } from '@/components/ui/scroll-area';
import { DEFAULT_SECTION_TYPES } from '@/config/sectionDefaults';

interface SectionLayoutViewerProps {
  isOpen: boolean;
  onClose: () => void;
  sectionIds: string[];
}

// Maps section IDs to readable names and descriptions from defaults
const sectionInfoMap = DEFAULT_SECTION_TYPES.reduce<Record<string, { name: string; description?: string }>>((acc, s) => {
  acc[s.id] = { name: s.name, description: s.description };
  return acc;
}, {});

const SectionLayoutViewer: React.FC<SectionLayoutViewerProps> = ({ isOpen, onClose, sectionIds }) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>Proposed structure</DialogTitle>
        </DialogHeader>
        <ScrollArea className="max-h-[60vh]">
          {Array.isArray(sectionIds) && sectionIds.length > 0 ? (
            <ul className="space-y-2 pr-2">
              {sectionIds.map((id, idx) => {
                const info = sectionInfoMap[id];
                return (
                  <li key={`${id}-${idx}`} className="border rounded-md p-3 bg-background">
                    <div className="text-sm font-medium">
                      {idx + 1}. {info?.name || id}
                    </div>
                    {info?.description && (
                      <div className="text-xs text-muted-foreground mt-1">
                        {info.description}
                      </div>
                    )}
                  </li>
                );
              })}
            </ul>
          ) : (
            <div className="text-sm text-muted-foreground">No sections available.</div>
          )}
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
};

export default SectionLayoutViewer;

